import { ca } from '@cian/analytics';

import { TOffer } from '../../types/offer';
import { getProducts } from '../../utils/trackings_helpers';

export const trackUnlockButtonClick = (offer?: TOffer, opponentId?: number) => {
  ca('eventSite', {
    action: `restore_message_from_spam`,
    category: 'Chat',
    name: 'oldevent',
    products: offer ? getProducts([offer]) : [],
    page: {
      extra: {
        opponent_id: opponentId,
      },
    },
  });
};
